import { render, staticRenderFns } from "./category.vue?vue&type=template&id=211e41fa&scoped=true&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style1 from "./category.vue?vue&type=style&index=1&id=211e41fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211e41fa",
  null
  
)

export default component.exports